export default __webpack_public_path__ + "08105bdd411b509dcf5e1b10e55c61bd.png";